import { render, staticRenderFns } from "./AdminListActions.vue?vue&type=template&id=4a7cbe72&"
import script from "./AdminListActions.vue?vue&type=script&lang=js&"
export * from "./AdminListActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports